import React from 'react';
import logo from '../images/sslmo-logo.png';
import {
  FooterContainer,
  Container,
  FooterContent,
  FooterLeft,
  FooterBrand,
  FooterNav,
  FooterNavLink,
  FooterBottom,
  FooterCopyright,
  FooterPolicies
} from './Footer.styled';

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterLeft>
            <FooterBrand>
              <img src={logo} alt="쓸모 로고" className="footer-logo" />
            </FooterBrand>
            
            <FooterNav>
              <FooterNavLink to="/">서비스 소개</FooterNavLink>
              <FooterNavLink to="/news">언론보도</FooterNavLink>
              <FooterNavLink to="/pricing">가격 안내</FooterNavLink>
              <FooterNavLink to="/blog">블로그</FooterNavLink>
            </FooterNav>
            
            <FooterBottom>
              <FooterCopyright>
                <p>&copy; 2025 SSLMO, All rights reserved</p>
              </FooterCopyright>
              
              <FooterPolicies>
                <a href="#privacy">개인정보 이용정책</a>
                <a href="#terms">이용약관</a>
              </FooterPolicies>
            </FooterBottom>
          </FooterLeft>
        </FooterContent>
      </Container>
    </FooterContainer>
  );
};

export default Footer;